import { render, staticRenderFns } from "./MoqsDiscountDetails.vue?vue&type=template&id=851bd140"
import script from "./MoqsDiscountDetails.vue?vue&type=script&lang=ts"
export * from "./MoqsDiscountDetails.vue?vue&type=script&lang=ts"
import style0 from "./MoqsDiscountDetails.vue?vue&type=style&index=0&id=851bd140&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('851bd140')) {
      api.createRecord('851bd140', component.options)
    } else {
      api.reload('851bd140', component.options)
    }
    module.hot.accept("./MoqsDiscountDetails.vue?vue&type=template&id=851bd140", function () {
      api.rerender('851bd140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/moqs-discounts/components/MoqsDiscountDetails.vue"
export default component.exports